import React, { useState } from "react";
import { Link } from "react-router-dom";
import s from "./Projects.module.css";
import img1 from "../images/Simulator Screenshot - iPhone 17 Pro - 2026-05-05 at 14.16.06.png";
import img2 from "../images/Simulator Screenshot - iPhone 17 Pro - 2026-05-05 at 14.23.50.png";
import img3 from "../images/AiInsight1.png";
import img4 from "../images/AiInsight2.png";
import img5 from "../images/PTSS.png";
import img6 from "../images/upsc.png";
import img7 from "../images/chatbot.png";
import img8 from "../images/comparison.png";
import img9 from "../images/recommendations.png";

import {useInView} from 'react-intersection-observer';

const projects = [
  {
    num: "001",
    tag: "PERSONAL",
    title: "CarBot Matching Assistant",
    desc: "A full-stack application that analyzes user preferences like budget, mileage and delivers personalized vehicle recommendations using a weighted scoring algorithm",
    stack: ["REACT.JS", "NODE.JS", "EXPRESS", "TYPESCRIPT", "AI"],
    gradient: "linear-gradient(135deg, #2dd4bf, #6366f1, #e879f9)",
    links: [
      {
        label: "Read More ↗",
        href: "https://github.com/rasleen298/carRecommenationEngine/",
      },
    ],
    img1: img7,
    img2: img8,
    img3: img9,
    img4: null,
  },
  {
    num: "002",
    tag: "PROFESSIONAL",
    label: "PROFESSIONAL PROJECT",
    title: "Poshan Tracker - Ministry of Women and Child Care",
    desc: "Led development on Poshan Tracker project - a nationwide app used by 1.3 million Anganwadi workers to track daily nutrition, and AI face authentication for Take-Home Rations.",
    stack: ["REACT NATIVE", "TYPESCRIPT", "SQLITE"],
    gradient: "linear-gradient(135deg, #f9a8d4, #fb923c, #fbbf24)",
    links: [
      {
        label: "READ MORE ↗",
        href: "https://www.poshantracker.in/",
      },
    ],
    img1: null,
    img2: img5,
    img3: null,
    img4: null,
  },
  {
    num: "003",
    label: "FEATURED PROJECT",
    title: "BloomLog - Journal App",
    desc: "A journal app with plenty of prompts generated by AI, intended to decluttering and mind relaxation. A private daily journal where you write, track your mood, and watch your streak grow. Features Offline Storage as well as Supabase server syncing for saving the diary forever.",
    stack: ["REACT NATIVE", "TYPESCRIPT", "SUPABASE", "SQLITE", "EXPO"], //'CLAUDE AI','LOVABLE AI'
    aiCompanions: ["Claude", "Lovable"],
    gradient: "linear-gradient(135deg, #a78bfa, #60a5fa, #34d399)",
    links: [{ label: "READ MORE ↗", href: "/bloomlog", internal: true }], //{ label: 'PLAY STORE ↗', href: '#' },
    img1: img1,
    img2: img2,
    img3: img3,
    img4: img4,
  },
  {
    num: "004",
    tag: "PROFESSIONAL",
    title: "UPSC Authentication App",
    desc: "Delivered a low latency solution used during NDA and CDS examinations ensuring smooth and live candidate authentication using face capture and admit card QR code.",
    stack: ["REACT NATIVE", "TYPESCRIPT", "SQLITE"],
    gradient: "linear-gradient(135deg, #2dd4bf, #6366f1, #e879f9)",
    links: [
      {
        label: "Read More ↗",
        href: "https://x.com/drajaykumar_ias/status/1967107572386910312?t=tLib07AaTMhKtS879TPQKg&s=08",
      },
    ],
    img1: img6,
    img2: null,
    img3: null,
    img4: null,
  },
];

export default function Projects() {
  const [active, setActive] = useState(0);
  const project = projects[active];
  const [ref,inView] = useInView({triggerOnce:true}); //pass optional threshold value if required

  const increment = () =>
    setActive((prev) => (prev + 1) % projects.length || 0);

  return (
    <section className={s.section} id="projects">
      <div className={s.inner}>
        <div className={s.header}>
          <div>
            <span className={`${s.sectionTag} reveal`}>03 — SELECTED WORK</span>
            <h2 className={`${s.heading} reveal d1`}>Projects</h2>
          </div>
          <span onClick={() => increment()}>Next →</span>
        </div>

        <div className={s.layout} >
          <div className={`${s.visual} reveal d2`} ref={ref}>
          {inView ? (
            <div className={s.imageGrid} key={active}>
              {project.img1 ? (
                <img
                  src={project.img1}
                  alt="BloomLog screenshot 1"
                  className={s.projectImg}
                />
              ) : null}
              {project.img2 ? (
                <img
                  src={project.img2}
                  alt="BloomLog screenshot 2"
                  className={s.projectImg}
                />
              ) : null}
              <div className={s.imageColumn}>
                {project.img3 ? (
                  <img
                    src={project.img3}
                    alt="BloomLog screenshot 3"
                    className={s.projectImgSmall}
                  />
                ) : null}
                {project.img4 ? (
                  <img
                    src={project.img4}
                    alt="BloomLog screenshot 4"
                    className={s.projectImgSmall}
                  />
                ) : null}
              </div>
            </div>
          ) : null}
          </div>

          {/* Right: info */}
          <div className={`${s.info} reveal d3`}>
            <p className={s.infoLabel}>{project.label}</p>
            <h3 className={s.infoTitle}>{project.title}</h3>
            <p className={s.infoDesc}>{project.desc}</p>
            <div className={s.stack}>
              {project.stack.map((t) => (
                <span key={t} className={s.stackTag}>
                  {t}
                </span>
              ))}
            </div>
            {/* <div className={s.stack}>
              <p className={s.infoDesc}>AI Companions:</p>
              {project.aiCompanions.map(t => (
                <span key={t} className={s.stackTag}>{t}</span>
              ))}
            </div> */}

            <div className={s.infoActions}>
              {project.links.map((l) =>
                l.internal ? (
                  <Link
                    key={l.label}
                    to={l.href}
                    className={s.btnGhost}
                  >
                    {l.label}
                  </Link>
                ) : (
                  <a
                    key={l.label}
                    href={l.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={
                      l.label.includes("LIVE") ||
                      l.label.includes("NPM") ||
                      l.label.includes("CHROME")
                        ? s.btnPrimary
                        : s.btnGhost
                    }
                  >
                    {l.label}
                  </a>
                )
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
